// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  min-width: 0;
}

.filter-trigger {
  --background: var(--ion-color-light, #f4f5f8);
  --border-radius: 6px;
  --min-height: 42px;
  --padding-start: 10px;
  --inner-padding-end: 6px;
  transition: transform 180ms ease, filter 180ms ease;
}

.filter-trigger:active {
  transform: translateY(1px);
}

ion-popover {
  --width: min(24rem, calc(100vw - 2rem));
  --max-height: min(30rem, 72vh);
}

.popover-content {
  max-height: min(30rem, 72vh);
  overflow-y: auto;
}

.option-selected {
  --background: rgba(var(--ion-color-success-rgb), 0.09);
}`, "",{"version":3,"sources":["webpack://./src/app/_components/select/option-combobox/option-combobox.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,6CAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,mDAAA;AACF;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,uCAAA;EACA,8BAAA;AACF;;AAEA;EACE,4BAAA;EACA,gBAAA;AACF;;AAEA;EACE,sDAAA;AACF","sourcesContent":[":host {\n  display: block;\n  min-width: 0;\n}\n\n.filter-trigger {\n  --background: var(--ion-color-light, #f4f5f8);\n  --border-radius: 6px;\n  --min-height: 42px;\n  --padding-start: 10px;\n  --inner-padding-end: 6px;\n  transition: transform 180ms ease, filter 180ms ease;\n}\n\n.filter-trigger:active {\n  transform: translateY(1px);\n}\n\nion-popover {\n  --width: min(24rem, calc(100vw - 2rem));\n  --max-height: min(30rem, 72vh);\n}\n\n.popover-content {\n  max-height: min(30rem, 72vh);\n  overflow-y: auto;\n}\n\n.option-selected {\n  --background: rgba(var(--ion-color-success-rgb), 0.09);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
